import { useEffect, useMemo } from 'react'
import { toast } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { SELF_REGISTERED_QUERY_PARAM } from '@/views/PublicCatalogRouter/hooks/openCatalogCourseFlow'
import { useIsFirstLoginAfterRegister } from './useIsFirstLoginAfterRegister'

export const useHandleFirstLoginAfterRegister = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchAsObject = useMemo(() => Object.fromEntries(new URLSearchParams(searchParams)), [searchParams])
  const { t } = useTranslation()

  const isFirstLoginAfterRegister = useIsFirstLoginAfterRegister()

  useEffect(() => {
    // user just registered, not need to something else except showing toaster
    if (!isFirstLoginAfterRegister) {
      return
    }
    delete searchAsObject[SELF_REGISTERED_QUERY_PARAM]

    setTimeout(() => {
      setSearchParams(new URLSearchParams(searchAsObject).toString())

      toast.success(t('accountCreated'))
    }, 100)
  }, [isFirstLoginAfterRegister, searchAsObject, setSearchParams, t])
}
